import { createModalContext } from "shared/components/vero-modal";

export const {
  useModalContext: useResendToPmsModal,
  Provider: ResendToPmsModalProvider,
} = createModalContext();
